/**
 * Pto.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProjectFileDto } from '../model/project-file-dto';
import { ProjectFileSimpleDto } from '../model/project-file-simple-dto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../services';


@Injectable({
  providedIn: 'root'
})
export class ProjectFileService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration
    , private apiService: ApiService) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param projectID 
     * @param blobName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public projectsProjectIDFilesBlobNameDelete(projectID: number, blobName: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public projectsProjectIDFilesBlobNameDelete(projectID: number, blobName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public projectsProjectIDFilesBlobNameDelete(projectID: number, blobName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public projectsProjectIDFilesBlobNameDelete(projectID: number, blobName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectID === null || projectID === undefined) {
            throw new Error('Required parameter projectID was null or undefined when calling projectsProjectIDFilesBlobNameDelete.');
        }

        if (blobName === null || blobName === undefined) {
            throw new Error('Required parameter blobName was null or undefined when calling projectsProjectIDFilesBlobNameDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/projects/${encodeURIComponent(String(projectID))}/files/${encodeURIComponent(String(blobName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(catchError((error: any) => { return this.apiService.handleError(error)}));
    }

    /**
     * 
     * 
     * @param projectID 
     * @param blobName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public projectsProjectIDFilesBlobNameDownloadGet(projectID: number, blobName: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public projectsProjectIDFilesBlobNameDownloadGet(projectID: number, blobName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public projectsProjectIDFilesBlobNameDownloadGet(projectID: number, blobName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public projectsProjectIDFilesBlobNameDownloadGet(projectID: number, blobName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectID === null || projectID === undefined) {
            throw new Error('Required parameter projectID was null or undefined when calling projectsProjectIDFilesBlobNameDownloadGet.');
        }

        if (blobName === null || blobName === undefined) {
            throw new Error('Required parameter blobName was null or undefined when calling projectsProjectIDFilesBlobNameDownloadGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/projects/${encodeURIComponent(String(projectID))}/files/${encodeURIComponent(String(blobName))}/download`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(catchError((error: any) => { return this.apiService.handleError(error)}));
    }

    /**
     * 
     * 
     * @param projectID 
     * @param blobName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public projectsProjectIDFilesBlobNameGet(projectID: number, blobName: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFileDto>;
    public projectsProjectIDFilesBlobNameGet(projectID: number, blobName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFileDto>>;
    public projectsProjectIDFilesBlobNameGet(projectID: number, blobName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFileDto>>;
    public projectsProjectIDFilesBlobNameGet(projectID: number, blobName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectID === null || projectID === undefined) {
            throw new Error('Required parameter projectID was null or undefined when calling projectsProjectIDFilesBlobNameGet.');
        }

        if (blobName === null || blobName === undefined) {
            throw new Error('Required parameter blobName was null or undefined when calling projectsProjectIDFilesBlobNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProjectFileDto>(`${this.basePath}/projects/${encodeURIComponent(String(projectID))}/files/${encodeURIComponent(String(blobName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(catchError((error: any) => { return this.apiService.handleError(error)}));
    }

    /**
     * 
     * 
     * @param projectID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public projectsProjectIDFilesGet(projectID: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectFileSimpleDto>>;
    public projectsProjectIDFilesGet(projectID: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectFileSimpleDto>>>;
    public projectsProjectIDFilesGet(projectID: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectFileSimpleDto>>>;
    public projectsProjectIDFilesGet(projectID: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectID === null || projectID === undefined) {
            throw new Error('Required parameter projectID was null or undefined when calling projectsProjectIDFilesGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProjectFileSimpleDto>>(`${this.basePath}/projects/${encodeURIComponent(String(projectID))}/files`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(catchError((error: any) => { return this.apiService.handleError(error)}));
    }

    /**
     * 
     * 
     * @param projectID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public projectsProjectIDFilesPost(projectID: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectFileDto>>;
    public projectsProjectIDFilesPost(projectID: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectFileDto>>>;
    public projectsProjectIDFilesPost(projectID: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectFileDto>>>;
    public projectsProjectIDFilesPost(projectID: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectID === null || projectID === undefined) {
            throw new Error('Required parameter projectID was null or undefined when calling projectsProjectIDFilesPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Array<ProjectFileDto>>(`${this.basePath}/projects/${encodeURIComponent(String(projectID))}/files`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(catchError((error: any) => { return this.apiService.handleError(error)}));
    }

}
